import React from "react";
import RichText from "../../Prismic/RichText";
import EditableLinks from "./EditableLinks";
import isEmpty from "lodash/isEmpty";
import UpsellItems from "../UpsellItems";
import PropTypes from "prop-types";

const EditableContent = (props) => {
  const hasGiftwrapAddons = !isEmpty(props.giftwrapAddons);
  const hasExtraAddons = !isEmpty(props.extraAddons);

  return (
    <React.Fragment>
      <span className="line-item-ii-customisation">
        {!isEmpty(props.expandedCustomisation) ? (
          <RichText fields={props.expandedCustomisation} />
        ) : (
          props.displayFormat
        )}
      </span>

      {hasGiftwrapAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-ii-option line-item-option--giftwrap">
          + {props.giftwrapAddons.map((addon) => addon.label).join(" + ")}
        </span>
      )}

      {hasExtraAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-ii-option line-item-option--giftwrap">
          + {props.extraAddons.map((addon) => addon.label).join(" + ")}
        </span>
      )}

      {!props.isMobile && (
        <>
          {props.isEnableUpsell && (
            <UpsellItems
              item={props.item}
              countryModel={props.model.countryModel}
              handleEditAddon={props.handleEditAddon}
              availableAddons={
                props.isEnableUpsell ? props.availableAddons : []
              }
            />
          )}
          <EditableLinks {...props} />
        </>
      )}
    </React.Fragment>
  );
};

EditableContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  displayFormat: PropTypes.string.isRequired,
  giftwrapAddons: PropTypes.array,
  extraAddons: PropTypes.array,
  isCustomisationsExpanded: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
  isEnableUpsell: PropTypes.bool,
  item: PropTypes.object,
  model: PropTypes.shape({
    countryModel: PropTypes.object,
  }),
  handleEditAddon: PropTypes.func,
  availableAddons: PropTypes.array,
};

export default EditableContent;
